import React from "react";

export function VehicleItemSkeleton() {
  return (
    <div className="bg-white rounded-3xl p-5 border border-gray-100 shadow-sm flex flex-col justify-between animate-pulse">
      <div>
        <div className="w-full h-44 rounded-2xl bg-gray-200 mb-4" />
        <div className="flex items-center justify-between mb-2">
          <div className="h-6 bg-gray-200 rounded-md w-3/5" />
          <div className="h-6 bg-gray-200 rounded-md w-1/4" />
        </div>
        <div className="flex items-center gap-2 mb-4">
          <div className="h-4 bg-gray-200 rounded-md w-16" />
          <div className="h-4 bg-gray-200 rounded-md w-20" />
        </div>
      </div>
      <div className="h-11 bg-gray-200 rounded-xl w-full mt-4" />
    </div>
  );
}

export default VehicleItemSkeleton;
